export enum ApprovalStatus {
  NotStarted,
  Pending,
  Approved,
  Rejected,
  RequestForQuotation,
}

export const getApprovalStatusInfo = (
  status: ApprovalStatus
): { name: string; color: string } => {
  const { Approved, NotStarted, Pending, Rejected, RequestForQuotation } =
    ApprovalStatus;

  switch (status) {
    case NotStarted:
      return { name: "NotStarted", color: "gray" };
    case Pending:
      return { name: "Pending", color: "#ffa500" };
    case Approved:
      return { name: "Approved", color: "#28a745" };
    case Rejected:
      return { name: "Rejected", color: "#f86e7b" };
    case RequestForQuotation:
      return { name: "RequestForQuotation", color: "#ffc107" };
    default:
      return { name: "Unknown", color: "black" }; // Fallback case
  }
};

export const approvalStatusArray = Object.keys(ApprovalStatus)
  .filter((key) => isNaN(Number(key))) // Filter out numeric keys
  .map((key) => ({
    value: ApprovalStatus[key as keyof typeof ApprovalStatus], // Enum value
    label: key, // Enum name
  }));
